module.exports = __webpack_public_path__ + "c7d4252a03858ecb1d463d6bdeb4e304.png";